module.exports = __webpack_public_path__ + "static/img/wordpress.3945861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/wordpress.png
// module id = cq3b
// module chunks = 0 139